<template>
  <Teleport to="body">
    <div
      v-show="!isMobile && !isAirGroundCollaborationPage"
      class="floating-actions"
      data-text-reveal="off"
    >
      <button
        type="button"
        class="floating-action toup"
        :class="{ 'toup-active': isShowUpBtn }"
        :aria-hidden="!isShowUpBtn"
        :tabindex="isShowUpBtn ? 0 : -1"
        aria-label="返回顶部"
        @click="toTop"
      >
        <img src="@/assets/images/svgs/up.svg" alt="" />
      </button>

      <button
        type="button"
        class="floating-action contact-action"
        aria-label="联系我们"
        @click="goContact"
      >
        <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
          <circle class="contact-action__ring" cx="24" cy="24" r="21" />
          <g class="contact-action__support" transform="translate(12 12)">
            <path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z" />
            <path d="M21 16v2a4 4 0 0 1-4 4h-5" />
          </g>
        </svg>
      </button>
    </div>
  </Teleport>
</template>

<script setup>
import { useScreenWidth } from '@/js/useScreenWidth'
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useRouter } from 'vue-router';

const router = useRouter()
const route = useRoute()
const isMobile = useScreenWidth()
const isShowUpBtn = ref(false);
const isAirGroundCollaborationPage = computed(() => route.path === '/solution/air-ground-collaboration')

const getScrollTop = () => document.documentElement.scrollTop || document.body.scrollTop;

const handleScroll = () => {
  isShowUpBtn.value = getScrollTop() > 200;
};

const toTop = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.scrollTo({
    top: 0,
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  });
};

const goContact = () => {
  router.push('/about/contact#contact-form');
};

onMounted(() => {
  handleScroll();
  window.addEventListener('scroll', handleScroll, { passive: true });
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style>
.floating-actions {
  position: fixed !important;
  z-index: 1000;
  right: 50px !important;
  bottom: 38px !important;
  width: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  pointer-events: none;
}

.floating-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  pointer-events: auto;
  transition: opacity 0.25s ease, visibility 0.25s ease, transform 0.25s ease;
}

.toup {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.toup img {
  display: block;
  width: 48px;
  height: 48px;
  filter: invert(1);
  mix-blend-mode: difference;
}

.contact-action svg {
  display: block;
  width: 48px;
  height: 48px;
  fill: none;
  stroke: #444;
  filter: invert(1);
  mix-blend-mode: difference;
}

.contact-action__ring {
  stroke-width: 3;
}

.contact-action__support {
  stroke-width: 2.3;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.toup-active {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.floating-action:hover {
  transform: translateY(-2px);
}

.floating-action:focus-visible {
  outline: 2px solid var(--pixso-color-primary, #2f80ed);
  outline-offset: 4px;
}

@media (prefers-reduced-motion: reduce) {
  .floating-action {
    transition: none;
  }

  .floating-action:hover {
    transform: none;
  }
}
</style>
